import { instance, IQueryParams, IResponse } from 'services';

import { ICategoryResource } from './category.types';

export const CategoryResources = {
  get: (params?: IQueryParams): IResponse<ICategoryResource[]> =>
    instance.get('/repository-categories', { params }),
};
